module.exports = __webpack_public_path__ + "img/icon-loading.9fd0245c.svg";